import { render, staticRenderFns } from "./MessageListBottom.vue?vue&type=template&id=edeb506c&"
import script from "./MessageListBottom.vue?vue&type=script&lang=ts&"
export * from "./MessageListBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports